import $ from 'jquery';

/* this module affects the sector page open and scroll down */

module.exports = function () {

    // Scroll to sector if the route includes a particular sector
    let scrollToSector = function () {
        if ($('#sector-to-show-id').val().length) {
            $('html, body').animate({
                scrollTop: $('#sector-' + $('#sector-to-show-id').val()).click().offset().top
            }, 2000);
        }
    };

    setTimeout(scrollToSector, 500);

};
